import * as React from "react";
import { UitkCard, UitkCardContent, UitkCardTextSegment } from "uitk-react-cards";
import { UitkIcon } from "uitk-react-icons";
import { MobileMenuProps, DesktopMenuProps, Landmark } from "../typings";

const generateLandmarksList = (landmarks: Landmark[]) =>
  landmarks.map((landmark: Landmark) => (
    <li key={landmark.id} tabIndex={0} onClick={landmark.onClick}>
      <UitkIcon name="place" />
      {landmark.title}
      <p className="is-visually-hidden">{landmark.description}</p>
    </li>
  ));

export const MobileMenu = (props: MobileMenuProps) => (
  <UitkCard>
    <UitkCardContent>
      <UitkCardTextSegment className="uitk-card-separator-bottom">
        <div className="mobile-nav-card__toggle" onClick={props.toggle}>
          <div className="uitk-grid" tabIndex={0}>
            <div className="uitk-cell all-cell-fill">
              <h2 className="uitk-type-heading-500">{props.title}</h2>
            </div>
            <div className="uitk-cell all-cell-1-6 uitk-type-right">
              <UitkIcon name={props.isOpen ? "expand_more" : "expand_less"} />
            </div>
          </div>
        </div>
      </UitkCardTextSegment>
      <UitkCardTextSegment className="map-menu">
        <ul className="map-menu__items" tabIndex={0}>
          {generateLandmarksList(props.landmarks)}
        </ul>
      </UitkCardTextSegment>
    </UitkCardContent>
  </UitkCard>
);

export const DesktopMenu = (props: DesktopMenuProps) => (
  <UitkCard className="map-explorer">
    <UitkCardContent>
      <UitkCardTextSegment className="uitk-card-separator-bottom">
        <div className="uitk-grid" tabIndex={0}>
          <div className="uitk-cell all-cell-fill">
            <h2 className="uitk-type-heading-500">{props.title}</h2>
          </div>
        </div>
      </UitkCardTextSegment>
      <UitkCardTextSegment className="map-menu">
        <ul className="map-menu__items">{generateLandmarksList(props.landmarks)}</ul>
      </UitkCardTextSegment>
    </UitkCardContent>
  </UitkCard>
);
